<template>
  <v-card v-if="personnel_etc_groupAll > 0" outlined rounded="lg" :loading="loading" class="pa-3 h-100">
    <div class="section-card-title">
      <v-icon color="#B3151B" class="mr-2">mdi-account-multiple</v-icon>
      บุคลากรทั้งหมด (แยกตามประเภท)
      <span class="section-card-count">{{ numberWithCommas(personnel_etc_groupAll) }} คน</span>
    </div>

    <div v-if="!loading">
      <apexchart type="donut" height="300" :options="chartOptions" :series="series"></apexchart>
    </div>
  </v-card>
</template>

<script>
// ข้อมูลอัตรากำลังบุคลากรรวม (ทุกประเภท) ของสถานศึกษา — มาจากระบบ HRvec_openapi กลาง (เกตเวย์แยกต่างหาก
// นอกโค้ดฐานนี้) ไม่ใช่ตาราง personnel_etc ในนี้โดยตรง จึงยังคง fetch เองต่อไป (เพื่อความทนทาน ถ้า endpoint
// นี้ล่ม/ช้า จะไม่ทำให้ widget อื่นในหน้าพัง) แล้วส่งผลลัพธ์ให้ parent ผ่าน "loaded" สำหรับส่งออก Excel
export default {
  name: "OcsMasterMouchartdonut",

  data() {
    return {
      ApiKey: "HRvec2021",
      loading: false,
      personnel_etc_groups: [],
      series: [],
      personnel_etc_groupAll: 0,
      chartOptions: { chart: { type: "donut" } }
    };
  },

  async mounted() {
    await this.personnel_etc_groupQueryID();
  },

  methods: {
    numberWithCommas(x) {
      x = String(x);
      const pattern = /(-?\d+)(\d{3})/;
      while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
      return x;
    },

    async personnel_etc_groupQueryID() {
      this.loading = true;
      let result = await this.$http
        .post("personnel_etc_group_id.php", { ApiKey: this.ApiKey, college_id: this.college_ID })
        .finally(() => (this.loading = false));
      this.personnel_etc_groups = Array.isArray(result.data) ? result.data : [];

      const labelText = [];
      const valuesst = [];
      let counts = 0;
      this.personnel_etc_groups.forEach(value => {
        counts += parseInt(value.countGrouptype) || 0;
        labelText.push(value.user_status_name + " : " + this.numberWithCommas(value.countGrouptype));
        valuesst.push(parseFloat((value.countGrouptype * 100) / value.countAll).toFixed(2));
      });

      this.personnel_etc_groupAll = counts;
      this.series = valuesst.map(Number);
      this.chartOptions = {
        chart: { type: "donut" },
        labels: labelText,
        colors: ["#B3151B", "#1B365D", "#A86400", "#424242", "#8E1014", "#9E9E9E", "#212121"],
        legend: { position: "bottom", fontFamily: "Kanit" },
        dataLabels: { formatter: val => val.toFixed(1) + "%" }
      };

      this.$emit("loaded", this.personnel_etc_groups);
    }
  },

  computed: {
    college_ID() {
      return this.$route.query.college_ID;
    }
  }
};
</script>

<style scoped>
.h-100 {
  height: 100%;
}
.section-card-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-weight: 700;
  color: #1b365d;
  font-size: 1rem;
  margin-bottom: 8px;
}
.section-card-count {
  margin-left: auto;
  font-weight: 700;
  color: #b3151b;
}
</style>
